export default __webpack_public_path__ + "static/media/AudioLIS2.0-ExcelentePractica.4a0e4767.mp3";